var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-banner"},[_c('div',{staticClass:"signup-banner__title"},[_vm._v(_vm._s(_vm.$t("homepage.joinUs")))]),_c('v-btn',{attrs:{"rounded":"","color":"#f75007","dark":"","x-large":"","to":"signup"}},[_vm._v(" "+_vm._s(_vm.$t("homepage.getStartedToday"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }